import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, FeaturesConfigModule, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import {
  defaultViewConfig,
  IconModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  ProductListModule,
  SpinnerModule,
  StarRatingModule,
  ViewConfig,
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddToCartModule } from '../../cart/add-to-cart/add-to-cart.module';
import { ItemCounterModule } from '../../cart/item-counter/item-counter.module';
import { PromotionalTextModule } from '../../promotional-text/promotional-text.module';
import { SearchResultsModule } from '../../search-results/search-results.module';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { ProductPromotionsModule } from '../product-promotions/product-promotions.module';
import { ProductStockInfoModule } from '../product-stock-info/product-stock-info.module';
import { ShimanoProductListComponent } from './container/shimano-product-list.component';
import { ShimanoProductScrollComponent } from './container/shimano-product-scroll/shimano-product-scroll.component';
import { ProductGridItemComponent } from './product-grid-item/product-grid-item.component';
import { ProductListGridModalComponent } from './product-list-grid-modal/product-list-grid-modal.component';
import { ProductListItemComponent } from './product-list-item/product-list-item.component';
import { ProductRefinementComponent } from './product-refinement/product-refinement.component';
import { ProductSortingComponent } from './product-sorting/product-sorting.component';
import { ProductViewComponent } from './product-view/product-view.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    // AddToCartModule,
    // ItemCounterModule,
    ListNavigationModule,
    UrlModule,
    I18nModule,
    StarRatingModule,
    IconModule,
    SpinnerModule,
    InfiniteScrollModule,
    FeaturesConfigModule,
    OutletModule,
    TooltipIconModule,
    PromotionalTextModule,
    MatTooltipModule,
    MatIconModule,
    MatSidenavModule,
    NgSelectModule,
    FormsModule,
    MatProgressSpinnerModule,
    ProductListModule,
    SearchResultsModule,
    SharedModule,
    ItemCounterModule,
    NgbDropdownModule,
    ProductPromotionsModule,
    ProductStockInfoModule,
    AddToCartModule,
  ],
  providers: [
    provideConfig(<ViewConfig>defaultViewConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductRefinementComponent: {
          component: ProductRefinementComponent,
        },
        CMSProductListComponent: {
          component: ShimanoProductListComponent,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.PlpGridCart,
    }),
  ],
  declarations: [
    ShimanoProductListComponent,
    ProductListItemComponent,
    ProductGridItemComponent,
    ProductViewComponent,
    ShimanoProductScrollComponent,
    ProductRefinementComponent,
    ProductSortingComponent,
    ProductListGridModalComponent,
  ],
  exports: [
    ShimanoProductListComponent,
    ProductListItemComponent,
    ProductGridItemComponent,
    ProductViewComponent,
    ShimanoProductScrollComponent,
    ProductRefinementComponent,
    ProductSortingComponent,
    ProductListGridModalComponent,
  ],
})
export class ShimanoProductListModule {}
